import React, { useState, FC, useEffect } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, useTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { userState } from "../../../../states/userState";
import { setUserToLocalStorage } from "../../../../functions/localStorageManager";
import {
  backgroundColor,
  foreColor,
  foreColorOnMouseOver,
} from "../../../../commons/colors";
import { User } from "../../../types/user";

type Props = {
  fullWidth: boolean;
  label: string;
  multiline: boolean;
  required: boolean;
  rows: number;
  type: string;
  InputProps?: TextFieldProps["InputProps"];
  placeholder: string;
  disabled: boolean;
  productNo: string;
  setProductNo: React.Dispatch<React.SetStateAction<string>>;
  productBno: string;
  setProductBno: React.Dispatch<React.SetStateAction<string>>;
  setToggleFocus: React.Dispatch<React.SetStateAction<boolean>>;
  fetchProcess: (
    aProductNo?: string,
    aProductBno?: string,
    aSalesNo?: string
  ) => Promise<void>;
};
const TextInputForProductNo: FC<Props> = (props) => {
  const {
    productNo,
    setProductNo,
    productBno,
    setProductBno,
    setToggleFocus,
    fetchProcess,
  } = props;
  const [user, setUser] = useRecoilState<User>(userState);
  // const [productNo, setProductNo] = useState(user.initialParameters.productNo);
  const theme = useTheme();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const regex = /^\d{0,8}$/; // 最大8桁の数字のみを許可する正規表現

    if (regex.test(value)) {
      setToggleFocus(true);
      setProductNo(value);
    }
  };
  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setProductNo("");
    setProductBno("");
    setUser((prevUser: User) => {
      // const newUser: User = { ...prevUser, isAuth: true };
      // デフォルト値を設定
      // const defaultInitialParams: InitialParameters = {
      //   workersForInput: [],
      //   workersForList: [],
      //   factoryNo: [],
      //   productNo: "",
      //   productBno: "",
      //   latestUrl: "",
      // };
      const newUser: User = {
        ...prevUser,
        filters: {
          // ...defaultInitialParams,
          ...prevUser.filters,
          productNo: "",
        },
      };
      //LocalStorageにユーザ情報をセット
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  const handleOnBlur = (e: React.FocusEvent<HTMLElement>) => {
    let setString =
      String(productNo).length > 0 ? String(productNo).padStart(8, "0") : "";
    setProductNo(setString);
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        filters: {
          ...prevUser.filters,
          productNo: setString,
        },
      };
      //LocalStorageにユーザ情報をセット
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  const handleKeyDown = async (e: any) => {
    if (e.key === "Enter") {
      e.target.blur();
      let setString =
        String(e.target.value).length > 0
          ? String(e.target.value).padStart(8, "0")
          : "";
      await fetchProcess(
        setString,
        user.filters.productNo.split("-")[1],
        user.filters.salesNo
      );
    }
  };
  return (
    <TextField
      // color={"#0adcc0"}
      variant="standard"
      fullWidth={props.fullWidth}
      label={props.label}
      InputLabelProps={{ shrink: true }}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={productNo}
      type={props.type}
      onChange={handleOnChange}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      onKeyDown={handleKeyDown}
      disabled={props.disabled}
      placeholder={props.placeholder}
      InputProps={{
        ...props.InputProps,
        endAdornment: props.InputProps ? (
          // <InputAdornment position="start">
          //   <div
          //     style={{
          //       backgroundColor: "#0adcc0",
          //       width: "36px",
          //       height: "20px",
          //       paddingLeft: "6px",
          //       borderRadius: "5px",
          //       cursor: "pointer",
          //     }}
          //     onClick={props.onClick}
          //   >
          //     <SearchIcon />
          //   </div>
          // </InputAdornment>
          <></>
        ) : null,
        sx: {
          "& .MuiInput-underline:before": {
            borderBottomColor: foreColor(user?.mode ?? "lite"), // 通常時の下線の色
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: foreColor(user?.mode ?? "lite"), // フォーカス時の下線の色
          },
          "& .MuiInput-underline:hover:before": {
            borderBottomColor: `${foreColor(user?.mode ?? "lite")}!important`, // ホバー時の下線の色
          },
          "& .MuiInput-underline": {
            borderBottomColor: `${foreColor(user?.mode ?? "lite")}!important`, // ホバー時の下線の色
          },
          // 他のスタイルもここに追加できます
        },
      }}
      sx={{
        margin: "20px 0",

        "&&&": {
          // color: "blue",
          width: "95px",
          height: "42px",
          backgroundColor: backgroundColor(user?.mode ?? "lite"),
          padding: "5px 10px 2px 10px",
          borderRadius: "5px",
        },
        "& label": {
          padding: "10px",
          color: foreColor(user?.mode ?? "lite"),
          fontSize: "18px",
        },
        "& svg": {
          // marginTop: "5px",
          color: "#f0f2f5",
        },
        "& input": {
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: "5px",
          paddingLeft: "2px",
          fontSize: "16px",
          color: foreColor(user?.mode ?? "lite"),
          fontWeight: "700",
          "&:hover": {
            color: foreColor(user?.mode ?? "lite"),
          },
          "&:focus": {
            color: foreColor(user?.mode ?? "lite"),
          },
          //   backgroundColor: "black",
        },
        "& .MuiSvgIcon-root": {
          color: "#f0f2f5",
        },
        "& .MuiInputBase-input": {
          fontSize: "16px",
          color: foreColor(user?.mode ?? "lite"),
          fontWeight: "700",
        },
        // InputPropsで指定したスタイル以外にもここで追加できます
      }}
    />
  );
};
export default TextInputForProductNo;
